/**
 * useCommandPalette -- global Cmd+K / Ctrl+K shortcut hook.
 *
 * A3-3 (Sprint 1): Returns { open, setOpen, toggle }.
 * Listens for Cmd+K on Mac and Ctrl+K on Win/Linux.
 * Also listens for 'aif:open-command-palette' custom event (fired by TopBar trigger).
 */

import { useState, useEffect, useCallback } from 'react';

export default function useCommandPalette() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((v) => !v), []);

  useEffect(() => {
    const handleKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        toggle();
      }
    };
    const handleCustom = () => setOpen(true);

    window.addEventListener('keydown', handleKey);
    window.addEventListener('aif:open-command-palette', handleCustom);
    return () => {
      window.removeEventListener('keydown', handleKey);
      window.removeEventListener('aif:open-command-palette', handleCustom);
    };
  }, [toggle]);

  return { open, setOpen, toggle };
}
